import { getDeliveryWindowIdsFromVariants } from '@app/logic/deliveryWindows';
import React from 'react';

import { useLookbookProductsByIds } from './useLookbookProductsByIds';
import { useLookbookWishlist } from './useLookbookWishlist';

export const ACCOUNT_REQUEST_DETAILS_QUERY_KEY = 'accountRequestWishlist';

interface Props {
  lookbookId: string | undefined;
  wishlistId: string | undefined;
}

export const useLookbookWishlistProducts = ({ lookbookId, wishlistId }: Props) => {
  const { data: wishlistData, isLoading: isLoadingWishlist } = useLookbookWishlist({
    lookbookId,
    wishlistId,
  });
  const wishlist = React.useMemo(() => wishlistData?.products ?? [], [wishlistData?.products]);
  const { data: wishlistProductsData, isLoading: isLoadingProducts } = useLookbookProductsByIds({
    lookbookId,
    products: [...wishlist],
  });
  const isLoading = isLoadingWishlist || isLoadingProducts;

  const products = React.useMemo(() => wishlistProductsData ?? [], [wishlistProductsData]);
  const deliveryWindows = React.useMemo(() => getDeliveryWindowIdsFromVariants(products), [products]);

  return React.useMemo(
    () => ({
      deliveryWindows,
      isLoading,
      products,
      wishlist,
    }),
    [products, isLoading, wishlist, deliveryWindows],
  );
};
